import * as React from 'react';
export class RowSeparatorHandleRenderer extends React.PureComponent {
    render() {
        return React.createElement("div", { style: { position: 'relative', width: 6, height: '100%' } },
            React.createElement("div", { style: {
                    backgroundColor: 'black',
                    position: 'absolute',
                    cursor: 'pointer',
                    top: 0,
                    left: this.props.offset,
                    width: '100%',
                    height: '100%'
                } }));
    }
}
//# sourceMappingURL=row-separator-handle-renderer.js.map